/* Unaöd, diagnostic soin (repris de la maquette V7)
   Zone (ongles, mains, pieds) → 1 à 4 questions → routine, affichée sans condition.
   Sous la routine, une carte propose de la recevoir par e-mail avec le code -10 % : l'envoi du formulaire vaut accord
   (texte explicite sous le bouton, pas de case à cocher), et le code n'apparaît qu'après l'inscription.
   Chaque réponse pose une étiquette sur la fiche cliente, avec les libellés de l'ancien quiz RevenueHunt
   quand ils existent, pour que les segments Brevo restent valables. */
(function () {
  const root = document.querySelector('[data-u-dg]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  const D = JSON.parse(root.querySelector('[data-u-dg-data]').textContent);
  const P = D.products || {}, I = D.img || {};
  const $ = (s) => root.querySelector(s), $$ = (s) => [...root.querySelectorAll(s)];
  const esc = (x) => String(x || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const euros = (c) => (c / 100).toFixed(2).replace('.', ',') + ' €';
  const has = (h) => !!P[h];
  const name = (h) => (P[h] ? P[h].name : h);
  const KEY = 'unaod-diag';
  const store = { get() { try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; } }, set(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} } };

  const DSOS = 'baume-ongles-sos-ongles-abimes', DECL = 'baume-ongles-eclat-des-ongles', DDIS = 'dissolvant-solide-doux-sans-acetone', DKIT = 'kit-manucure-pour-ongles-naturels';
  const DSAV = 'savon-mains-nectar-de-bruyere', DGOM = 'le-gommage-mains-nectar-de-bruyere', DCRE = 'la-creme-mains-nectar-de-bruyere', DONG = 'onguent-pieds-secs', DHUI = 'huile-seche-regenerante';
  const DCOF = 'coffret-routine-soin-des-mains-nectar-de-bruyere', DDUO = 'duo-gommage-et-creme';

  // [valeur, libellé, précision, étiquette cliente, image]
  const Q = {
    zone: { q: 'Quel soin cherchez-vous ?', lead: 'Choisissez la zone qui vous préoccupe le plus. Vous pourrez refaire le test pour une autre.', cols: 3, img: I.mains, note: ['Ongles, mains ou pieds', 'Chaque zone a ses questions, pour une routine qui vous ressemble.'],
      opts: [['ongles', 'Mes ongles', 'Cassants, ternes, vernis', 'diagnostic ongles', I.dissolvant], ['mains', 'Mes mains', 'Sèches, rêches, abîmées', 'diagnostic mains', I.creme], ['pieds', 'Mes pieds et mon corps', 'Talons secs, callosités', 'diagnostic pieds', I.pied]] },
    etat: { q: 'Comment sont vos ongles en ce moment ?', cols: 2, img: I.buis, note: ['Un ongle se renouvelle en six mois environ', 'Les bons gestes se voient dès les premières semaines.'],
      opts: [['mous', 'Mous', 'Ils plient au lieu de casser', 'ongles très abimés'], ['cassants', 'Cassants', 'Ils se fendent ou cassent net', 'ongles très abimés'], ['dedoubles', 'Dédoublés', 'Ils s\'effeuillent au bout', 'ongles très abimés'], ['stries', 'Striés', 'Des lignes en relief', 'ongles très abimés'], ['ternes', 'Ternes et secs', 'Sans éclat, déshydratés', 'ongles à améliorer'], ['sains', 'En forme', 'Je veux les garder ainsi', 'beaux ongles']] },
    vernis: { q: 'Vous posez du vernis…', img: I.vernis, note: ['Le vernis n\'est pas l\'ennemi', 'C\'est souvent la façon de le retirer qui abîme l\'ongle.'],
      opts: [['semaine', 'Chaque semaine ou presque', '', 'adepte vernis'], ['parfois', 'De temps en temps', 'Pour une occasion, un week-end', 'vernis occasionnellement'], ['semi', 'Du semi-permanent ou du gel', 'Pose en institut ou à la lampe UV', 'vernis gel/semi'], ['rare', 'Rarement ou jamais', '', 'pas de vernis']] },
    retrait: { q: 'Aujourd\'hui, vous le retirez…', img: I.dissolvant, note: ['Vingt secondes de pose', 'Le dissolvant solide se pose comme un masque, sans acétone.'],
      opts: [['acetone', 'Avec un dissolvant à l\'acétone', '', 'dissolvant acétone'], ['sansac', 'Avec un dissolvant liquide sans acétone', '', 'dissolvant sans acétone'], ['gratte', 'Je le gratte ou je le laisse partir', '', 'retire en grattant']] },
    cuticules: { q: 'Et le contour de vos ongles ?', img: I.buis, note: ['Les cuticules protègent l\'ongle', 'On les repousse, on ne les coupe pas.'],
      opts: [['longues', 'Les cuticules débordent sur l\'ongle', '', 'cuticules à repousser'], ['seches', 'Sec, des petites peaux accrochent', '', 'cuticules sèches'], ['ok', 'Rien à signaler', '', '']] },
    peau: { q: 'Vos mains sont plutôt…', img: I.creme, note: ['Nos mains, lavées vingt fois par jour', 'Elles méritent mieux qu\'un savon qui dessèche.'],
      opts: [['seches', 'Sèches', 'Elles tiraillent', 'mains sèches'], ['reches', 'Rêches', 'Des peaux sèches, un toucher rugueux', 'mains sèches'], ['tres', 'Très sèches, abîmées', 'Crevasses, gerçures, peaux qui pèlent', 'mains très abimés'], ['entretien', 'Plutôt confortables', 'Je veux les entretenir', 'mains confortables']] },
    lavage: { q: 'Vos mains sont exposées à l\'eau ou aux produits ménagers…', img: I.savon, note: ['Le savon surgras à 8 %', 'Il lave sans retirer le film qui protège la peau.'],
      opts: [['peu', 'Peu', '1 à 2 fois par jour', ''], ['moderee', 'Modérément', '3 à 5 fois par jour', ''], ['intensif', 'Intensément', 'Plus de 5 fois par jour, enfants, cuisine, métier exposé', 'lavages mains intensifs']] },
    pied: { q: 'Qu\'est-ce qui vous gêne ?', img: I.pied, note: ['Un résultat dès la première application', 'L\'onguent assouplit les zones rugueuses.'],
      opts: [['talons', 'Des talons secs', '', 'pieds secs'], ['callosites', 'Des callosités, des zones rugueuses', '', 'callosités'], ['corps', 'La peau du corps qui tiraille', '', 'peau du corps sèche'], ['tout', 'Les pieds et le corps', '', 'pieds secs']] }
  };

  let saved = store.get();
  let justSent = false;
  let A = {}, step = -1, contact = saved && saved.email && saved.consent ? { prenom: saved.prenom, email: saved.email, consent: true } : null;

  function steps() {
    const s = ['zone'];
    if (A.zone === 'ongles') s.push('etat', 'vernis', ...(A.vernis === 'semaine' || A.vernis === 'parfois' ? ['retrait'] : []), 'cuticules');
    if (A.zone === 'mains') s.push('peau', 'lavage');
    if (A.zone === 'pieds') s.push('pied');
    return s;
  }
  const total = () => (!A.zone ? 5 : steps().length);

  // Offre groupée : prix réel, « au lieu de » = somme des produits séparés, livraison offerte si au-dessus du seuil
  // La composition vient de la fiche des coffrets du thème (snippets/u-coffret-def.liquid) quand elle existe.
  // Économie affichée seulement si tous les éléments sont vendus seuls : « X € de moins qu'à l'unité ».
  function bundleText(h, parts, label) {
    const b = P[h]; if (!b) return null;
    const def = (D.coffrets || {})[h];
    if (def && def.parts && def.parts.length) parts = def.parts;
    const all = parts.every((x) => P[x]) && !(def && def.extras);
    const sum = parts.reduce((a, x) => a + (P[x] ? P[x].price : 0), 0);
    let t = label + ' ' + b.money + (all && sum > b.price ? ', soit ' + euros(sum - b.price) + ' de moins qu\'à l\'unité' : '');
    if (b.price >= D.seuil) t += ', livraison offerte';
    return t + '.';
  }

  /* ---------- Résultat ---------- */
  function result() {
    const why = [], st = [];
    let title = '', bundle = null, extra = null;
    if (A.zone === 'ongles') {
      const pose = A.vernis === 'semaine' || A.vernis === 'parfois', abime = ['mous', 'cassants', 'dedoubles', 'stries'].includes(A.etat);
      const L = { mous: 'Des ongles mous', cassants: 'Des ongles cassants', dedoubles: 'Des ongles qui se dédoublent', stries: 'Des ongles striés', ternes: 'Des ongles ternes et secs', sains: 'Des ongles en forme' };
      const V = { semaine: ', du vernis chaque semaine', parfois: ', du vernis de temps en temps', semi: ', du semi-permanent ou du gel', rare: '' };
      title = L[A.etat] + V[A.vernis];
      if (A.retrait === 'acetone') why.push('L\'acétone dessèche l\'ongle à chaque dépose : c\'est le premier geste à changer.');
      if (A.retrait === 'gratte') why.push('Gratter le vernis emporte aussi des couches de l\'ongle : un dissolvant doux évite ce geste.');
      if (A.retrait === 'sansac') why.push('Bon réflexe. Le dissolvant solide va plus loin : il nourrit l\'ongle pendant le geste et ne coule pas.');
      if (A.vernis === 'semi') why.push('Notre dissolvant ne retire pas le semi-permanent ni le gel : faites-le déposer par votre prothésiste, puis nourrissez l\'ongle entre deux poses.');
      why.push(abime ? 'Le baume SOS nourrit et protège les ongles abîmés, mous, cassants ou striés.' : 'Le baume éclat nourrit les ongles secs et déshydratés au quotidien.');
      if (A.cuticules === 'seches') why.push('Massez le baume sur l\'ongle et son contour, le soir.');
      if (pose) st.push(['Retirer', DDIS, 'Une couche, vingt secondes de pose, la lingette']);
      st.push(['Nourrir', abime ? DSOS : DECL, abime ? 'Ongles mous, cassants ou striés' : 'Ongles secs, sans éclat']);
      if (A.cuticules === 'longues') st.push(['Préparer', DKIT, 'Lime et bâton de buis pour repousser les cuticules']);
      if (pose && abime && D.rituel && has(D.rituel)) bundle = [D.rituel, 'Toute votre routine dans le rituel ongles', (D.rituelText ? D.rituelText + ' ' : '') + P[D.rituel].money + (P[D.rituel].price >= D.seuil ? ', livraison offerte.' : '.')];
      if (st.length === 1 && A.cuticules !== 'longues') extra = [DKIT, 'Lime et bâton de buis pour préparer l\'ongle et repousser les cuticules'];
    } else if (A.zone === 'mains') {
      const L = { seches: 'Des mains sèches', reches: 'Des mains rêches', tres: 'Des mains très sèches et abîmées', entretien: 'Des mains à entretenir' };
      title = L[A.peau] + (A.lavage === 'intensif' ? ', très souvent lavées' : '');
      const savon = A.lavage === 'intensif' || A.peau === 'tres', gom = A.peau === 'reches' || A.peau === 'tres';
      if (savon) { st.push(['Laver', DSAV, 'Surgras à 8 %, saponifié à froid']); why.push('Le savon surgras lave sans dessécher, même à chaque lavage.'); }
      if (gom) { st.push(['Exfolier', DGOM, 'Une fois par semaine, en douceur']); why.push('Le gommage retire les peaux sèches et prépare la peau à la crème.'); }
      st.push(['Nourrir', DCRE, 'Pénètre vite, sans film collant']); why.push('La crème nourrit, protège et apaise les mains sèches à sensibles.');
      const tCof = bundleText(DCOF, [DSAV, DGOM, DCRE], 'Savon, gommage et crème.');
      const tDuo = bundleText(DDUO, [DGOM, DCRE], 'Le gommage et la crème.');
      if (savon && gom && tCof) bundle = [DCOF, 'Toute votre routine en coffret', tCof];
      else if (gom && !savon && tDuo) bundle = [DDUO, 'Le gommage et la crème en duo', tDuo];
      if (st.length === 1) extra = [DSAV, 'Le savon surgras lave sans dessécher, avant la crème'];
      else if (savon && !gom && tCof) extra = [DCOF, 'Ajoutez le gommage : toute la routine en coffret. ' + tCof];
    } else {
      const L = { talons: 'Des talons secs', callosites: 'Des callosités', corps: 'Une peau du corps qui tiraille', tout: 'Des pieds secs et une peau du corps qui tiraille' };
      title = L[A.pied];
      if (A.pied !== 'corps') { st.push(['Pieds', DONG, 'Le soir, sur peau propre']); why.push('L\'onguent assouplit les zones rugueuses et les callosités, avec un résultat visible dès la première application.'); }
      if (A.pied === 'corps' || A.pied === 'tout') { st.push(['Corps', DHUI, 'Corps, visage, décolleté']); why.push('L\'huile sèche nourrit la peau sans la graisser.'); }
      if (A.pied === 'talons' || A.pied === 'callosites') extra = [DHUI, 'Pour nourrir aussi la peau du corps, sans la graisser'];
      if (A.pied === 'corps') extra = [DONG, 'Si vos talons sont secs aussi : résultat visible dès la première application'];
    }
    return { title, why, st: st.filter((x) => has(x[1])), bundle, extra: extra && has(extra[0]) ? extra : null };
  }

  function tags(r) {
    const t = new Set(['diagnostic']);
    steps().forEach((k) => { const o = Q[k].opts.find((x) => x[0] === A[k]); if (o && o[3]) t.add(o[3]); });
    if (contact && contact.age) t.add(contact.age);
    (r.bundle ? [r.bundle[0]] : r.st.map((s) => s[1])).forEach((h) => t.add('reco ' + name(h).toLowerCase()));
    return [...t];
  }

  /* ---------- Écrans ---------- */
  function setSide(img, note) {
    const el = $('[data-u-dg-img]');
    if (img && el.getAttribute('src') !== img) { el.style.opacity = 0; setTimeout(() => { el.src = img; el.style.opacity = 1; }, 250); }
    if (note) { $('[data-u-dg-note-t]').textContent = note[0]; $('[data-u-dg-note-s]').textContent = note[1]; }
  }
  function top(n) {
    root.dataset.screen = n === 'done' ? 'done' : n === -1 ? 'intro' : 'q';
    const pct = n === 'done' ? 100 : n < 0 ? 0 : Math.round(((n + 1) / (total() + 1)) * 100);
    $('[data-u-dg-top]').innerHTML = `${n !== -1 && n !== 'done' ? '<button type="button" class="u-dg__back" data-u-dg-back>← Retour</button>' : '<span class="u-dg__back u-dg__brand">Diagnostic soin</span>'}
      <div class="u-dg__prog"><i style="width:${pct}%"></i></div>
      <span class="u-dg__step">${n === 'done' ? 'Votre routine' : n < 0 ? '1 minute' : `Question ${n + 1}`}</span>`;
  }
  const body = (html) => { const b = $('[data-u-dg-body]'); b.innerHTML = `<div class="u-dg__body">${html}</div>`; $('.u-dg__main').scrollTop = 0; root.scrollTop = 0; };
  /* 03/11/2026 : chaque écran du test ajoute une entrée d'historique, le bouton retour du téléphone revient à la question précédente au lieu de quitter le site */
  let fromPop = false;
  function remember() {
    if (root.hidden || fromPop) return;
    const s = history.state;
    if (s && s.udg && s.step === step) return;
    const n = s && s.udg ? s.n + 1 : 1;
    history.pushState({ udg: 1, step, n }, '', location.pathname + location.search + '#quiz');
  }
  function render() {
    remember();
    const S = steps();
    if (step === -1) return intro();
    if (step < S.length) return question(S[step]);
    return showResult();
  }
  function intro() {
    top(-1);
    setSide(I.buis, ['Le bon soin, en une minute.', 'Formulé en Bretagne par Marine, biologiste, et Gaëlle, chimiste.']);
    body(`<span class="u-eyebrow">Diagnostic soin</span>
      <h2 class="u-h1">${esc(D.introTitle)}</h2>
      <p class="u-dg__lead">${esc(D.introLead)}</p>
      <ol class="u-dg__intro">
        <li><i>1</i><span>2 à 5 questions, selon la zone choisie</span></li>
        <li><i>2</i><span>Votre routine, et le coffret qui la contient quand il est plus avantageux</span></li>
        ${D.code ? '<li><i>3</i><span>-10 % sur votre première commande si vous recevez la routine par e-mail</span></li>' : ''}
      </ol>
      <button type="button" class="u-btn" data-u-dg-start>Commencer <span class="u-arrow">→</span></button>
      ${saved && saved.zone ? `<p class="u-dg__again">Vous avez déjà fait le diagnostic ${saved.zone === 'pieds' ? 'pieds et corps' : saved.zone}. <a class="u-link" href="#" data-u-dg-last>Revoir ma routine</a></p>` : ''}`);
  }
  function question(k) {
    const d = Q[k], idx = steps().indexOf(k);
    top(idx);
    setSide(d.img, d.note);
    body(`<span class="u-eyebrow">Question ${idx + 1}</span>
      <h2 class="u-h1 u-dg__q">${d.q}</h2>
      ${d.lead ? `<p class="u-dg__lead">${d.lead}</p>` : '<div class="u-dg__sp"></div>'}
      <div class="u-dg__opts${d.cols ? ' u-dg__opts--' + d.cols : ''}">${d.opts.map(([v, t, s, , im]) => `<button type="button" class="u-dg__opt${im ? ' u-dg__opt--img' : ''}${A[k] === v ? ' is-on' : ''}" data-dq="${k}" data-dv="${v}">${im ? `<span class="u-dg__opt-img"><img src="${im}" alt="" loading="lazy"></span><span class="u-dg__opt-t">` : ''}<b>${t}</b>${s ? `<small>${s}</small>` : ''}${im ? '</span>' : ''}</button>`).join('')}</div>`);
  }
  // Carte d'inscription sous la routine : l'envoi vaut accord, le code est la récompense
  function signup() {
    if (contact && contact.consent) {
      const msg = justSent
        ? `C'est noté : votre routine et nos conseils arrivent à <b>${esc(contact.email)}</b>.`
        : `Vous êtes déjà inscrite avec <b>${esc(contact.email)}</b>${D.code ? ' : votre code reste valable sur votre première commande' : ''}.`;
      return `${D.code ? `<div class="u-dg__gift"><code>${esc(D.code)}</code><p><b>-10 % sur votre première commande.</b> À saisir au paiement.</p></div>` : ''}
        <p class="u-dg__sent"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M6 12.5l4 4 8-9"/></svg><span>${msg}</span></p>`;
    }
    return `<form class="u-dg__optin" data-u-dg-form novalidate>
        <div class="u-dg__optin-head">
          ${D.code ? '<span class="u-dg__optin-tag">-10 %</span>' : ''}
          <div><b>${D.code ? 'Recevez votre routine et votre code -10 %' : 'Recevez votre routine par e-mail'}</b>
          <span>Votre routine dans votre boîte mail${D.code ? ', et le code pour votre première commande' : ''}.</span></div>
        </div>
        <div class="u-dg__optin-fields">
          <label class="u-dg__input"><span class="visually-hidden">Votre prénom (facultatif)</span><input name="prenom" autocomplete="given-name" placeholder="Prénom (facultatif)"></label>
          <label class="u-dg__input" data-email><span class="visually-hidden">Votre adresse e-mail</span><input name="email" type="email" autocomplete="email" inputmode="email" required placeholder="Adresse e-mail"><span class="u-dg__err" hidden>Vérifiez votre adresse e-mail.</span></label>
        </div>
        <button class="u-btn u-dg__submit">${D.code ? 'Recevoir mon code' : 'Recevoir ma routine'}</button>
        <p class="u-dg__legal">En validant, vous acceptez de recevoir nos conseils de soin et nos offres par e-mail. Désinscription en un clic dans chaque e-mail. <a class="u-link" href="${esc(D.privacy)}" target="_blank" rel="noopener">Confidentialité</a></p>
      </form>`;
  }
  // Produits conseillés, en clés courtes lues par l'e-mail Brevo.
  // P1 : le soin principal. P2 : les soins en plus, joints par « + » (ordre fixe).
  function recoKeys(r) {
    const in_ = (h) => r.st.some((s) => s[1] === h);
    const join = (pairs) => pairs.filter(([h]) => in_(h)).map(([, k]) => k).join('+');
    if (A.zone === 'ongles') return { p1: in_(DSOS) ? 'sos' : in_(DECL) ? 'eclat' : '', p2: join([[DDIS, 'dissolvant'], [DKIT, 'kit']]) };
    if (A.zone === 'mains') return { p1: in_(DCRE) ? 'creme' : '', p2: join([[DSAV, 'savon'], [DGOM, 'gommage']]) };
    return { p1: join([[DONG, 'onguent'], [DHUI, 'huile']]), p2: '' };
  }
  function subscribe(r) {
    // 05/11/2026 : inscription directe dans Brevo (formulaire Brevo, liste « Diagnostic site »).
    // L'ancien formulaire client Shopify caché était bloqué par la protection anti-robots de Shopify.
    if (!D.brevo || !contact || !contact.consent) return;
    const k = recoKeys(r), fd = new FormData();
    Object.entries({ EMAIL: contact.email, FIRSTNAME: contact.prenom || '', DIAG_ZONE: A.zone || '', DIAG_TITRE: r.title || '', DIAG_P1: k.p1, DIAG_P2: k.p2, email_address_check: '', locale: 'fr' })
      .forEach(([n, v]) => fd.append(n, v));
    const url = D.brevo + (D.brevo.includes('?') ? '&' : '?') + 'isAjax=1';
    fetch(url, { method: 'POST', body: fd, keepalive: true }).catch(() => fetch(url, { method: 'POST', body: fd, mode: 'no-cors' }).catch(() => {}));
    justSent = true;
    store.set({ ...(store.get() || {}), sent: contact.email });
    saved = store.get();
  }
  function showResult() {
    const r = result(), tg = tags(r);
    store.set({ ...(contact || {}), sent: saved && saved.sent, zone: A.zone, answers: A, tags: tg, date: new Date().toISOString().slice(0, 10) });
    saved = store.get();
    // Cliente déjà connue (e-mail gardé par le navigateur) mais jamais envoyée à Brevo :
    // cas des diagnostics faits avant le branchement Brevo. On l'inscrit maintenant.
    justSent = false;
    if (contact && contact.consent && saved.sent !== contact.email) subscribe(r);
    top('done');
    setSide(A.zone === 'mains' ? I.creme : A.zone === 'pieds' ? I.pied : I.dissolvant, ['Votre routine Unaöd', 'Formulée et fabriquée en Bretagne.']);
    const tot = r.st.reduce((a, s) => a + P[s[1]].price, 0);
    const card = (h, lab, sub) => `<li><a class="u-dg__thumb" href="${P[h].url}" tabindex="-1" aria-hidden="true">${P[h].img}</a><div><small>${lab}</small><a href="${P[h].url}">${esc(name(h))}</a><span>${sub}</span></div><button type="button" class="u-mini-add" data-u-dg-add="${h}">+ ${P[h].money}</button></li>`;
    const others = ['ongles', 'mains', 'pieds'].filter((z) => z !== A.zone);
    const ZL = { ongles: 'ongles', mains: 'mains', pieds: 'pieds et corps' };
    body(`<div class="u-dg__res-head"><span class="u-eyebrow">${contact && contact.prenom ? esc(contact.prenom) + ', voici' : 'Voici'} votre diagnostic</span><h2 class="u-h1 u-dg__q">${r.title}</h2></div>
      <div class="u-dg__why">${r.why.map((w) => `<p>${w}</p>`).join('')}</div>
      ${r.bundle ? `<div class="u-dg__bundle"><a class="u-dg__thumb" href="${P[r.bundle[0]].url}" tabindex="-1" aria-hidden="true">${P[r.bundle[0]].img}</a><div><b>${r.bundle[1]}</b><span>${r.bundle[2]}</span><button type="button" class="u-btn u-btn--sm" data-u-dg-add="${r.bundle[0]}" data-u-dg-open>Ajouter le coffret</button></div></div>` : ''}
      <h3 class="u-dg__h3">${r.bundle ? 'Ou produit par produit' : 'Votre routine'}</h3>
      <ol class="u-dg__routine">${r.st.map(([lab, h, sub]) => card(h, lab, sub)).join('')}</ol>
      ${r.extra ? `<h3 class="u-dg__h3">Pour aller plus loin</h3><ol class="u-dg__routine" style="counter-reset:r ${r.st.length}">${card(r.extra[0], 'En plus', r.extra[1])}</ol>` : ''}
      ${!r.bundle && r.st.length > 1 ? `<button type="button" class="u-btn u-dg__all" data-u-dg-all>Ajouter ma routine, ${euros(tot)}</button>` : ''}
      <button type="button" class="u-btn u-btn--ghost u-dg__all" data-u-dg-cart hidden>Voir mon panier</button>
      <div class="u-dg__signup" data-u-dg-signup>${signup()}</div>
      <div class="u-dg__actions">${others.map((z) => `<button type="button" class="u-btn u-btn--ghost u-btn--sm" data-u-dg-zone="${z}">Diagnostic ${ZL[z]}</button>`).join('')}<button type="button" class="u-btn u-btn--ghost u-btn--sm" data-u-dg-restart>Refaire le test</button></div>`);
  }

  /* ---------- Ouverture et fermeture ---------- */
  let lastFocus = null;
  function open(zone) {
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('u-dg-open');
    if (zone && Q.zone.opts.some((o) => o[0] === zone)) { A = { zone }; step = 1; } else if (step === -1 || step === undefined) { step = -1; }
    render();
    setTimeout(() => { const c = $('[data-u-dg-close]'); if (c) c.focus(); }, 50);
  }
  function close(viaHistory) {
    root.hidden = true;
    document.documentElement.classList.remove('u-dg-open');
    const s = history.state;
    if (!viaHistory && s && s.udg) history.go(-s.n);
    else if (/^#(quiz|diagnostic)/.test(location.hash)) history.replaceState(null, '', location.pathname + location.search);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function fromHash() {
    const m = location.hash.match(/^#(?:quiz|diagnostic)(?:-(ongles|mains|pieds))?$/);
    if (m) open(m[1]);
  }

  /* ---------- Interactions ---------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href*="#quiz"], a[href*="#diagnostic"]');
    if (a && !root.contains(a)) {
      const u = new URL(a.href, location.href);
      if (u.pathname === location.pathname || u.pathname === '/') {
        e.preventDefault();
        const m = u.hash.match(/^#(?:quiz|diagnostic)(?:-(ongles|mains|pieds))?$/);
        if (m) open(m[1]);
        return;
      }
    }
  });
  root.addEventListener('click', async (e) => {
    const t = e.target;
    if (t.closest('[data-u-dg-close]')) { close(); return; }
    if (t.closest('[data-u-dg-start]')) { step = 0; render(); return; }
    if (t.closest('[data-u-dg-last]')) { e.preventDefault(); A = saved.answers || {}; step = steps().length; render(); return; }
    const o = t.closest('[data-dq]');
    if (o) {
      const k = o.dataset.dq; A[k] = o.dataset.dv;
      if (k === 'zone') Object.keys(A).forEach((x) => { if (x !== 'zone') delete A[x]; });
      if (k === 'vernis' && !['semaine', 'parfois'].includes(A.vernis)) delete A.retrait;
      $$('[data-dq]').forEach((x) => x.classList.toggle('is-on', x === o));
      setTimeout(() => { step = steps().indexOf(k) + 1; render(); }, 220);
      return;
    }
    if (t.closest('[data-u-dg-back]')) { step = Math.max(-1, Math.min(step, steps().length) - 1); render(); return; }
    const ad = t.closest('[data-u-dg-add]');
    // 03/11/2026 : on reste sur le résultat après l'ajout, pour que la carte du code -10 % reste visible ; « Voir mon panier » ouvre le tiroir
    const showCart = () => { const c = $('[data-u-dg-cart]'); if (c) c.hidden = false; };
    if (ad && window.Unaod && P[ad.dataset.uDgAdd]) {
      const ok = await window.Unaod.add([{ id: P[ad.dataset.uDgAdd].id, quantity: 1 }], { silent: true });
      if (ok) { ad.textContent = ad.hasAttribute('data-u-dg-open') ? 'Coffret ajouté ✓' : 'Ajouté ✓'; ad.classList.add('is-done'); ad.disabled = true; showCart(); }
      return;
    }
    const all = t.closest('[data-u-dg-all]');
    if (all && !all.hasAttribute('data-u-dg-cart') && window.Unaod) {
      const btns = $$('.u-dg__routine:first-of-type [data-u-dg-add]:not(.is-done)');
      const items = btns.map((b) => ({ id: P[b.dataset.uDgAdd].id, quantity: 1 }));
      const ok = items.length ? await window.Unaod.add(items, { silent: true, message: 'Routine ajoutée au panier' }) : true;
      if (ok) {
        btns.forEach((b) => { b.textContent = 'Ajouté ✓'; b.classList.add('is-done'); });
        all.textContent = 'Routine ajoutée ✓'; all.disabled = true; showCart();
        const g = root.querySelector('[data-u-dg-signup]'); if (g) g.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
      return;
    }
    if (t.closest('[data-u-dg-cart]')) {
      close();
      const d = document.querySelector('cart-drawer');
      if (d && d.open) setTimeout(() => d.open(), 80); else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      return;
    }
    const z = t.closest('[data-u-dg-zone]');
    if (z) { A = { zone: z.dataset.uDgZone }; step = 1; render(); return; }
    if (t.closest('[data-u-dg-restart]')) { A = {}; step = 0; render(); }
  });
  root.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-u-dg-form]'); if (!f) return;
    e.preventDefault();
    const email = f.email.value.trim(), ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
    f.querySelector('[data-email]').classList.toggle('is-err', !ok);
    f.querySelector('.u-dg__err').hidden = ok;
    if (!ok) { f.email.focus(); return; }
    contact = { prenom: f.prenom.value.trim(), email, consent: true };
    const r = result(), tg = tags(r);
    store.set({ ...contact, sent: saved && saved.sent, zone: A.zone, answers: A, tags: tg, date: new Date().toISOString().slice(0, 10) });
    saved = store.get();
    subscribe(r);
    // On remplace seulement la carte, sans faire remonter la page
    const box = root.querySelector('[data-u-dg-signup]');
    if (box) { box.innerHTML = signup(); box.classList.add('is-done'); const c = box.querySelector('.u-dg__gift, .u-dg__sent'); if (c) { c.setAttribute('tabindex', '-1'); c.focus({ preventScroll: true }); } }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !root.hidden) close(); });
  window.addEventListener('popstate', (e) => {
    const s = e.state;
    if (s && s.udg) {
      fromPop = true;
      if (root.hidden) { root.hidden = false; document.documentElement.classList.add('u-dg-open'); }
      step = s.step; render();
      fromPop = false;
    } else if (!root.hidden) close(true);
  });
  window.addEventListener('hashchange', () => { if (!(history.state && history.state.udg)) fromHash(); });
  // Arrivée avec #quiz dans l'adresse : on retire le # de l'entrée d'arrivée, le test ajoute ensuite la sienne
  if (/^#(quiz|diagnostic)/.test(location.hash)) {
    const h = location.hash;
    history.replaceState(null, '', location.pathname + location.search);
    const m = h.match(/^#(?:quiz|diagnostic)(?:-(ongles|mains|pieds))?$/);
    if (m) open(m[1]);
  }
})();
